import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Alert
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import Shimmer from "react-shimmer-effect";

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import CreateBloc from '../Create/Blocs/CreateBloc'
import DatePicker from '../../../../helpers/ui/DatePicker'
import moment from 'moment'

class IndexView extends Component {

    updateBloc = new UpdateBloc();
    createBloc = new CreateBloc();

    queryParams = new URLSearchParams(window.location.search)
    userdata = JSON.parse(localStorage.getItem('userdata'))

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            dateList: [
                {
                    id : 1,
                    date: ""
                },
            ],
            document: null,
            failedInfo: "Gagal Terjadi Kesalahan",
            minDate: ""
        }
    }

    addDate = () => {
        let count = this.state.dateList.length;
        this.setState({
            dateList: [
                ...this.state.dateList,
                {
                    id : count == 0 ? (count+1) : this.state.dateList.slice(-1)[0].id + 1,
                    date : "",
                }
            ]
        })

        // console.log(this.state.dateList)
    }

    delDate = (data) => {
        console.log(data)
        this.setState({
            dateList: [
                ...this.state.dateList.filter((val) => val!=data)
                // (count-1)
            ]
        })
    }

    handleChangeInputLevel = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.dateList];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.date = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({dateList : items});
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.updateBloc.fetchUpdate(dataForm)
        // await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        if (this.hasDuplicatesValue(values.dates)){
            alert('Terdapat Tanggal yang sama. Mohon dikoreksi!')
            return
        }
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                uuid: this.state.dataForm.employee_wfh_uuid,
                employee_wfh_employee_uuid: this.state.dataForm?.employee_wfh_employee_uuid,
                employee_wfh_employee_nip: this.state.dataForm?.employee_wfh_employee_nip,
                employee_wfh_employee_name: this.state.dataForm?.employee_wfh_employee_name,
            },
            confirm: true
        })
    }

    hasDuplicatesValue = (array) => {
        return (new Set(array)).size !== array.length;
    }

    reformatDetailDate = (raw) => {
        return raw.map(function(data, index) {
          var newObj = {};
          newObj["id"] = index;
          newObj["date"] = data.employee_wfh_detail_date;
      
          return newObj;
        });
    }

    checkDate = () => {
        let dates = this.state.dataForm.dates;

        this.updateBloc.fetchCheckDate({
            employee_uuid: this.userdata.employee_uuid,
            ref_uuid: this.queryParams.get('uuid'),
            dates: dates.join(',')
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                // this.submitData()

                this.checkDate()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.checkDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    this.setState({ 
                        used_dates_count: response.used_dates_count,
                        used_dates: response.used_dates
                    })

                    if (response.used_dates_count == 0) {
                        this.submitData()
                    } else {
                        this.setState({
                            failedInfo: response.message,
                            loading: false,
                            failed: true,
                        });
                    }
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            dataForm: response,
                            dateList: this.reformatDetailDate(response.details),
                            document: response.document_letter
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        this.updateBloc.fetchDetail({uuid: this.queryParams.get('uuid') })

        this.createBloc.getMaxDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    console.log(response)
                    this.setState({ minDate: response.min_date })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.createBloc.fetchMaxDate({day:5})
    }

    componentWillUnmount(){
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
        this.updateBloc.checkDateChannel?.unsubscribe()
        this.createBloc.getMaxDateChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Ubah Pengajuan WFH</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Alert color="info" role="alert">
                                        <p><strong> Work from Home (WFH)</strong></p>
                                        <ul>
                                            <li>Pegawai yang mendapat penugasan WFH, wajib menyampaikan rencana dan laporan hasil WFH</li>
                                            <li>Pegawai yang mendapat penugasan WFH, tetap memperoleh uang makan dan tunjangan kinerja selama memenuhi ketentuan WFH</li>
                                            <li>Ketentuan WFH :
                                            <ol>
                                                <li>Pegawai membuat Surat Tugas (ST)/Surat Keterangan WFH melalui aplikasi persuratan atau di luar aplikasi persuratan</li>
                                                <li>ST/Surat Keterangan WFH ditandatangani (DS atau tanda tangan basah) oleh pejabat yang berwenang sesuai ketentuan</li>
                                                <li>Untuk pencatatan di Kepegawaian, <strong>5 hari kerja sebelum</strong> <strong>dimulainya WFH</strong>, pegawai menyampaikan rencana WFH dengan melampirkan ST/Surat Keterangan WFH yang sudah ditandatangani</li>
                                                <li>Bagian Kepegawaian melakukan verifikasi terhadap rencana WFH</li>
                                                <li>Jika rencana WFH disetujui, pada saat jadwal WFH, pegawai dapat melakukan presensi mobile dimana pun (Masuk dan Pulang).</li>
                                                <li><strong>Hasil presensi mobile tidak otomatis tercatat sebagai kehadiran pegawai, sampai pegawai menyampaikan laporan WFH</strong></li>
                                                <li>Pegawai menyampaikan laporan WFH kepada atasan langsung</li>
                                                <li>Atasan langsung memverifikasi laporan WFH</li>
                                                <li>Jika laporan WFH disetujui, maka presensi mobile akan tercatat sebagai kehadiran pegawai</li>
                                                <li>Jika tidak disetujui, maka pegawai dianggap tidak hadir</li>
                                                <li>Laporan WFH disusun dan disampaikan kepada atasan langsung secara harian</li>
                                                <li>Atasan Langsung dapat memverifikasi Laporan WFH paling lambat pada akhir bulan berjalan</li>
                                            </ol>
                                            </li>
                                        </ul>
                                        </Alert>

                                        <Alert color="info" role="alert">
                                        <p>
                                            <strong>SURAT KETERANGAN WFH</strong> <br />
                                            Surat Keterangan WFH digunakan ketika ketentuan WFO maksimal 100% (Yang diberikan WFH hanya pegawai dengan kondisi tertentu). Ditandatangani oleh Eselon I
                                            <br />
                                            <a href={ process.env.REACT_APP_SERVICE_CORE_URL + "/templates/Surat_Keterangan_WFH.docx" } target="_blank" rel="noreferrer">
                                                Unduh template...
                                            </a>
                                        </p>
                                        </Alert>

                                        <Alert color="info" role="alert">
                                        <p>
                                            <strong>SURAT TUGAS WFH</strong> <br />
                                            Surat Tugas WFH digunakan ketika ketentuan WFO kurang dari 100% (Wfo 75%, 50 %, 25%) Semua pegawai memiliki hak untuk menerima penugasan WFH. Ditandatangani oleh Eselon II
                                            <br />
                                            <a href={ process.env.REACT_APP_PERSURATAN_URL + "/outbox/daftardraft.html?create" } target="_blank" rel="noreferrer">
                                                Buat Surat Tugas (Klik Disini)
                                            </a>
                                        </p>
                                        </Alert>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="employee_wfh_letter_number"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Surat Tugas WFH <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="employee_wfh_letter_number"
                                                    placeholder="Nomor Surat Tugas WFH..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Surat Tugas WFH"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="employee_wfh_letter_number"
                                                    value={this.state.dataForm?.employee_wfh_letter_number}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                                Upload Surat Tugas 
                                            </label>
                                            <Col md="3">
                                                <FileInput
                                                    name="file"
                                                    placeholder="Upload Surat Tugas"
                                                    className="form-control"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.document !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document?.documents_path}>
                                                                        Download <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : '-'}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                                Tanggal WFH
                                            </label>
                                            <Col md="3">
                                                {
                                                    this.state.dateList.map((data, index) => {
                                                        return (
                                                            <div className="row" key={`in-${index}`}>
                                                                <div className="col-md-10">
                                                                    {
                                                                        this.state.minDate == "" ?
                                                                        <Shimmer>
                                                                            <div style={{ width: "100%", height: 40 }}></div>
                                                                        </Shimmer> 
                                                                        :
                                                                        <DatePicker 
                                                                            name={`dates[${index}]`}
                                                                            isWeekday={true}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            errorMessage="Masukan Tanggal"
                                                                            validate={{ required: { value: true } }}
                                                                            // minDate={moment().add(5, 'days').format('YYYY-MM-DD')}
                                                                            minDate={this.state.minDate}
                                                                            defaultValue={data.date}
                                                                        /> 
                                                                    }
                                                                </div>
                                                                <div className="col-md-2 text-right">
                                                                    {
                                                                        index == 0 ? 
                                                                        <div className="col-md-2 text-right">
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="success" 
                                                                                type="button"
                                                                                onClick={this.addDate}
                                                                                ><i className="uil-plus-circle"></i>
                                                                            </Button>
                                                                        </div> :
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="danger" 
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    this.delDate(data)
                                                                                }}
                                                                                ><i className="uil-trash-alt"></i>
                                                                            </Button>
                                                                    }
                                                                    
                                                                </div>
                                                            </div>
                                                        )    
                                                    })
                                                }
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.failedInfo}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pengajuan_wfh.html?'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);